import axios from '../../../utils/api'

const actions = {

  async findSetores () {
    const data = await axios({
      method: 'GET',
      url: 'produtividade/setores'
    })

    return data
  },

  async findProdutividade ({ commit }, filtro) {
    const data = await axios({
      method: 'POST',
      url: 'produtividade/findByFilter',
      data: {
        ...filtro
      }
    })

    return data
  },

  async findProdutividadeBySetor ({ commit }, filtro) {
    const data = await axios({
      method: 'POST',
      url: 'produtividade/findBySetoresFilter',
      data: {
        ...filtro
      }
    })

    return data
  },

  async findProdutividadeUsuario ({ commit }, filtro) {
    const data = await axios({
      method: 'POST',
      url: 'produtividade/findByFilterUsuario',
      data: {
        ...filtro
      }
    })

    return data
  }

}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/produtividade/produtividade.js